import { EffectCallback, useEffect, useRef } from 'react'

export const useOnce = (effect: EffectCallback, deps: any[] = []) => {
  const ref = useRef(false)

  useEffect(() => {
    if (ref.current) {
      return
    }

    if (deps.some((dep) => !dep)) {
      return
    }

    ref.current = true
    effect()
  }, deps)
}
